module.exports = __webpack_public_path__ + "img/uganda.1ad637d6.svg";